import moment from 'moment';

export const validateOnlyChacters = (name: string) => {
  const re = /^[a-zA-Z \s]+$/;
  return re.test(name);
};

export const validateOnlyNumbers = (number: string) => {
  const re = /^[0-9]{1,12}$/;
  return re.test(number);
};

export const validatePassword = (password: string) => {
  const re = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}/;
  return re.test(password);
};

export const validateEmail = (email: string) => {
  const re = /[a-z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  return re.test(email);
};

export const validatePhone = (phone: string) => {
  const re = /^(?:\+1\s?)?(?:\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/;
  return re.test(phone);
};


export const inputPhoneMasking = (value: string) => {

  let cleaned = value.replace(/\D/g, '');
  cleaned = cleaned.substring(0, 10);

  if (cleaned.length > 0) {
    if (cleaned.length <= 3) {
      return cleaned;
    } else if (cleaned.length <= 6) {

      return `(${cleaned.slice(0, 3)})-${cleaned.slice(3)}`;
    } else {

      return `(${cleaned.slice(0, 3)})-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
  }

  return cleaned;
};
export const inputSSNMasking = (e: string) => {
  let value = e;
  value = value.replace(/\D/g, '');
  value = value.replace(/^(\d{3})(\d{1,2})/, '$1-$2');
  value = value.replace(/^(\d{3})-(\d{2})(.+)/, '$1-$2-$3');
  value = value.substring(0, 11);

  return value;
};

export const unMasking = (e: string) => {
  let value = e;
  value = value.replaceAll('-', '');

  return value;
};

export const returnOnlyNumber = (data: string) => {
  let value = data;
  value = value.replace(/\D/g, '');
  return value;
};
export const returnShortAddress = (address: string) => {
  return address ? (address.length <= 40 ? address : address.slice(0, 40) + '...') : '';
};

export const returnShortString = (text: string, length?: number) => {
  const len = length ? length : 40;
  return text ? (text.length <= len ? text : text.slice(0, len) + '...') : '';
};

export const calculateAge = (dateString: string) => {
  var today = new Date();
  var birthDate = new Date(dateString);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};
export const cleanPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) return '';
  return phoneNumber.replace(/\D/g, '');
};
export const timeCheck = (date1: string, userTime: string) => {
  let dd = moment.utc(date1.toLocaleString()).format('MM/DD/YYYY') + ' ';
  let stt = new Date(dd + userTime);
  let stt1 = stt.getTime();
  let a = moment(stt1);
  if (a.diff(new Date()) < 0) {
    return true;
  } else {
    return false;
  }
};
